import VehicleMap from './vehicle-map.vue'
import Pagination, {
  Page
} from '../../../components/pagination'
import Vehicle from '../../../services/vehicles'
import Statements from '../../../services/statements'
import moment from 'moment'

const pageSize = 10;

let tenDaysAgo = new Date();

export default {
  data() {
    return {
      loading: undefined,
      selection: undefined,
      passages: undefined,
      summary: undefined,
      page: new Page(),
      customStart: tenDaysAgo,
      customEnd: new Date(),
      vehicle: undefined,
      totalValue: 0,
      totalPassages: 0,
      searchState: 'NOERROR',
      messageErro: undefined
    }
  },

  computed: {
    vehicleId() {
      return this.$route.params.vehicleId;
    },
    contractId() {
      return this.$route.params.contractId;
    },
    startDate() {
      return moment(this.customStart).startOf('day').valueOf()
    },
    endDate() {
      return moment(this.customEnd).endOf('day').valueOf()
    }
  },

  mounted() {
    this.find(true);
    Vehicle.getVehicleById(this.vehicleId).then(r => {
      this.vehicle = r;
    });

  },

  methods: {
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find(false);
    },
    find(updateSummary) {
      if (updateSummary)
        this.page = new Page(); //para comecar da pagina 1 de novo

      let filter = {
        contractId: this.contractId,
        vehicleId: this.vehicleId,
        startDate: this.startDate,
        endDate: this.endDate,
        page: this.page.build(),
        historicId: 1101
      };

      this.searchState = 'NOERROR';
      if (this.customEnd >= this.customStart) {
        this.loading = Statements.find(filter)
          .then(data => {
            
            this.passages = data.itens;
            //this.page = this.page.itemCount(10);
            this.page = this.page.itemCount(data.total);
            return Vehicle.listPassage(filter).then(sum => {
              
              if (updateSummary) {
                
                this.totalPassages = this.totalValue = 0;
                this.summary = sum.passageSummaryList;
                _.each(this.summary, obj => {
                  this.totalValue += obj.total;
                  this.totalPassages += obj.qtd;
                });
              }  
            });
          }).catch(error => {
            this.passages = undefined;
            this.summary = undefined;
            this.totalPassages = 0;
            this.totalValue = 0;

            
          });

      } else {
        this.searchState = 'ERROSEARCH';
        this.messageErro = (this.customEnd < this.customStart) ? 'Data final deve ser maior que a data inicial' : 'Outros';
      };
    }

  },

  components: {
    VehicleMap,
    Pagination
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/vehicle/vehicle-movement.js